import { FC, ChangeEvent } from 'react';
import { Box, FormControlLabel, Checkbox } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import { useApplications } from 'store/applications/hooks';
import useStyles from './HasOffersFilter.styles';

const HasOffersFilter: FC = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const {
    filters: { hasOffers },
    updateApplicationsQuery,
  } = useApplications();

  const onChangeHasOffers = (event: ChangeEvent<HTMLInputElement>, checked: boolean) => {
    updateApplicationsQuery({ hasOffers: checked });
  };

  return (
    <Box className={classes.checkboxContainer}>
      <FormControlLabel
        control={
          <Checkbox
            checked={!!hasOffers}
            onChange={onChangeHasOffers}
            name="hasOffers"
            color="secondary"
            size="medium"
          />
        }
        label={t('pages.dashboard.filters.hasOffers.title')}
      />
    </Box>
  );
};

export default HasOffersFilter;
